import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { useBrowserNotification } from '../../../hooks/useBrowserNotification';

const COUNTDOWN_SECONDS = 60;

const WorkStationInactivityModal = ({ show, onLogOut, onContinue }) => {
  const { translate: t } = useDictionaryTranslation();
  const { showNotification, closeNotification } = useBrowserNotification();
  const [secondsRemaining, setSecondsRemaining] = useState(COUNTDOWN_SECONDS);
  const originalTitleRef = useRef(document.title);
  const onLogOutRef = useRef(onLogOut);

  useEffect(() => {
    onLogOutRef.current = onLogOut;
  }, [onLogOut]);

  useEffect(() => {
    if (!show) {
      setSecondsRemaining(COUNTDOWN_SECONDS);
      document.title = originalTitleRef.current;
      closeNotification();
      return;
    }
    showNotification(t('inactivityWarning'), {
      body: t('inactivityLogoutMessage', { seconds: COUNTDOWN_SECONDS }),
      requireInteraction: true,
    });
    const intervalId = setInterval(() => {
      setSecondsRemaining(previousSeconds => (previousSeconds <= 1 ? 0 : previousSeconds - 1));
    }, 1000);
    return () => {
      clearInterval(intervalId);
      document.title = originalTitleRef.current;
    };
  }, [show]);

  useEffect(() => {
    if (secondsRemaining === 0 && show) {
      onLogOutRef.current();
    }
  }, [secondsRemaining, show]);

  useEffect(() => {
    if (!show) return;
    document.title = `⚠️ ${secondsRemaining}s`;
  }, [show, secondsRemaining]);

  return (
    <Modal
      open={show}
      title={t('inactivityWarning')}
      closable={false}
      footer={
        <Button type="primary" onClick={onContinue}>
          {t('continueSession')}
        </Button>
      }
    >
      {t('inactivityLogoutMessage', { seconds: secondsRemaining })}
    </Modal>
  );
};

WorkStationInactivityModal.propTypes = {
  show: PropTypes.bool,
  onLogOut: PropTypes.func,
  onContinue: PropTypes.func,
};

export { WorkStationInactivityModal };
